import { getRequest, postRequest, putRequest } from "@/services/networkService.js";

export async function CreatePanel(context, name) {
    let response = await postRequest(
        `panels/${context.appId}`,
        {
            name: name,
            panelType: 0
        },
        context
    );

    let responseJson = await response.json();

    if (response.ok) {
        return responseJson;
    } else {
        throw responseJson;
    }
}

export async function GetPanels(context) {
    let response = await getRequest(`panels/${context.appId}`, context);

    if (response.ok) {
        return await response.json();
    } else {
        throw new Error('Failed to get panels');
    }
}

export async function GetPanel(context, id) {
    let response = await getRequest(`panels/${context.appId}/${context.panelId}`, context);

    if (response.ok) {
        return await response.json();
    } else {
        throw new Error('Failed to get panel');
    }
}

export async function GetHistory(context) {
    let response = await getRequest(`panels/${context.appId}/${context.panelId}/history`, context);

    if (response.ok) {
        return await response.json();
    } else {
        throw new Error('Failed to get panel history');
    }
}

export async function UpdatePanel(context, panel) {
    let response = await putRequest(
        `panels/${context.appId}/${panel.id}`,
        panel,
        context
    );

    let responseJson = await response.json();

    if (response.ok) {
        return responseJson;
    } else {
        throw responseJson;
    }
}

export async function DeletePanel(context) {
    let response = await postRequest(
        `panels/${context.appId}/${context.panelId}/delete`,
        {},
        context
    );

    if (!response.ok) {
        throw new Error('Failed to delete panel');
    }
}